import { ThemeUICSSObject } from 'theme-ui';
/* IMPORT HERE */

const radio: ThemeUICSSObject = {
  width: '32px',
  height: '32px',
  input: {
    height: '32px !important',
  },
  path: {
    fill: 'inherit',
  },
};

export default radio;
